export const TRACKER_INVITE_MEMBER_DIALOG_CLICK = '[Invite Member Dialog] invite click';
export const TRACKER_INVITE_MEMBER_DIALOG_ERROR = '[Invite Member Dialog] invite error';
export const TRACKER_INVITE_MEMBER_DIALOG_SUCCESS = '[Invite Member Dialog] invite success';
